import { observer } from "mobx-react-lite"
import i from "../../../../translations/i";
import React from "react";
import { useParams } from "react-router-dom";
import { ParamTypes } from "../../../../helpers/types.interfaces";
import { FunctionComponent } from "../../../../components/FunctionComponent/FunctionComponent";

export const ModifiersGroup = observer(() => {

  const { id }: any = useParams<ParamTypes>()

  return <FunctionComponent
      options={{
        title: i.t('modifiersGroup:editTitle'),
        buttons: [
          { title: i.t('def:actions.backList'), href: `/shop/modifiers_groups`, type: 'dashed' },
          { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
        ],
        model: {
          enabled: true,
          name: '',
          required: false,
          min_count: 0,
          max_count: 0,
          view_type: 1,
          hidden: false,
          id_crm: '',
          sorting: 500,
          for_orders: false,
        },
        formAction: {
          path: '/modifiers_groups',
          isId: true,
          method: 'post',
          result: {
            notification: {
              message: i.t('def:success.complete'),
              description: i.t('def:success.edit')
            }
          }
        },
        items: [
          {
            type: 'form',
            requestData: (id && id > 0) ? {
              method: 'get',
              path: `/modifiers_groups/${id}`,
              isId: true,
              entity: 'model'
            } : null,
            fields: [
              {
                type: 'switch',
                items: [
                  { name: 'enabled', label: i.t('def:active') },
                  { name: 'required', label: i.t('modifiersGroup:requiredFem') },
                  { name: 'hidden', label: i.t('modifiersGroup:hiddenFem') },
                  // { name: 'for_orders', label: 'Для заказа' },
                ],
              },
              {
                type: 'input',
                name: 'name',
                span: 12,
                label: i.t('def:name')
              },
              {
                type: 'input',
                name: 'id_crm',
                span: 12,
                label: i.t('def:id_crm')
              },
              {
                type: 'number',
                name: 'min_count',
                span: 8,
                label: i.t('modifiersGroup:minCountForSelect')
              },
              {
                type: 'number',
                name: 'max_count',
                span: 8,
                label: i.t('modifiersGroup:maxCountForSelect')
              },
              {
                type: 'select',
                name: 'view_type',
                span: 8,
                label: i.t('def:View type'),
                data: [
                  { label: i.t('def:displays.e_2'), value: 1 },
                  { label: i.t('def:displays.e_1'), value: 2 },
                  { label: i.t('modifiersGroup:selector'), value: 3 },
                ],
                dataLabels: {
                  label: 'label',
                  id: 'value'
                }
              },
              {
                type: 'number',
                name: 'sorting',
                span: 8,
                label: i.t('modifier:sorting')
              },
            ],
          },
        ]
      }}
      form={true}
  />
})